import React, {Fragment, useState} from 'react';
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogList from '../../components/BlogList/BlogList.js'
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar'
import Logo from "../../images/caobangceritage.svg"
import blogs from '../../api/blogs';
import BotChatGPT from '../ChatbotPopUp';
import styles from './BlogSearchBar.module.css';
import AiVoice from '../../components/AiVoice/AiVoice';
const BlogPage =() => {
    const [keyword, setKeyword] = useState('');
    const [danToc, setDanToc] = useState('');
    const [loaiHoaTiet, setLoaiHoaTiet] = useState('');

    // Danh sách dân tộc và loại họa tiết mẫu, có thể lấy động từ blogs nếu muốn
    const danTocOptions = Array.from(
        new Set(blogs.map(blog => blog.danToc).filter(Boolean))
      );
      
      // Lấy danh sách loaiHoaTiet duy nhất (tách theo dấu phẩy)
      const loaiHoaTietOptions = Array.from(
        new Set(
          blogs
            .flatMap(blog =>
              blog.loaiHoaTiet
                ? blog.loaiHoaTiet.split(',').map(s => s.trim())
                : []
            )
            .filter(Boolean)
        )
      );

    return(
        <Fragment>
            <Navbar Logo={Logo} />
            <PageTitle pageTitle={'Bài nghiên cứu'} pagesub={'Blog'} />
            {/* Thanh search đẹp */}
            <div className={styles.searchBarWrapper}>
                <div className={styles.searchBar}>
                    <input
                        className={styles.searchInput}
                        type="text"
                        placeholder="Tìm kiếm từ khóa..."
                        value={keyword}
                        onChange={e => setKeyword(e.target.value)}
                    />
                    <select
                        className={styles.select}
                        value={danToc}
                        onChange={e => setDanToc(e.target.value)}
                    >
                        <option value="">Tất cả dân tộc</option>
                        {danTocOptions.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                    <select
                        className={styles.select}
                        value={loaiHoaTiet}
                        onChange={e => setLoaiHoaTiet(e.target.value)}
                    >
                        <option value="">Tất cả loại họa tiết</option>
                        {loaiHoaTietOptions.map(opt => (
                            <option key={opt} value={opt}>{opt}</option>
                        ))}
                    </select>
                    <button
                        className={styles.clearBtn}
                        onClick={() => { setKeyword(''); setDanToc(''); setLoaiHoaTiet(''); }}
                    >
                        Xóa lọc
                    </button>
                </div>
            </div>
            <BlogList keyword={keyword} danToc={danToc} loaiHoaTiet={loaiHoaTiet}/>
            <Footer />
            <AiVoice />
            <BotChatGPT />
        </Fragment>
    )
};
export default BlogPage;

